import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "trackId", "lessonId", "option"];
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped
import useLanguageRequested from '../../hooks/useLanguageRequests';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RequestLanguageButton = _ref => {
  let {
      children,
      trackId,
      lessonId,
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [languageRequested, setLanguageRequested] = useLanguageRequested({
    trackId,
    lessonId,
    language: option.value
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !option.disabled,
    headingText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.requestLanguage.notAvailable",
      options: {
        language: option.text
      }
    }),
    maxInlineSize: "400px",
    placement: "left",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.requestLanguage.${languageRequested ? 'requested' : 'request'}.tooltip`
    }),
    children: /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        justify: "between",
        children: [children, option.disabled && /*#__PURE__*/_jsx(View, {
          as: "span",
          color: languageRequested ? undefined : 'text-interactive-default',
          cursor: languageRequested ? undefined : 'pointer',
          onClick: setLanguageRequested,
          paddingBlock: "200",
          paddingInline: "500",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.requestLanguage.${languageRequested ? 'requested' : 'request'}.button`
          })
        })]
      })
    }))
  });
};
export default RequestLanguageButton;